import { ObjectIdentityTitle } from "../ObjectIdentityTitle";
import { withTimeSystem } from "../../constants/orbitMetadata";
import { getDisplayValue } from "./conjunctionUiUtils";
import { formatDate } from "../events/eventEvolutionUtils";

interface ConjunctionObjectTitleProps {
  cospar?: unknown;
  objectId?: unknown;
  name?: unknown;
  norad?: unknown;
  sourceOfInformation?: unknown;
  updateTime?: unknown;
}

export const ConjunctionObjectTitle = ({
  cospar,
  objectId,
  name,
  norad,
  sourceOfInformation,
  updateTime,
}: ConjunctionObjectTitleProps) => {
  const sourceValue = getDisplayValue(sourceOfInformation);
  const updateTimeValue = getDisplayValue(updateTime);
  const orbitInfo = `${sourceValue} | ${withTimeSystem(
    "Update Time",
  )}: ${formatDate(updateTimeValue)}`;

  return (
    <ObjectIdentityTitle
      cospar={getDisplayValue(cospar)}
      objectId={getDisplayValue(objectId)}
      linkToObject
      meta={orbitInfo}
      name={getDisplayValue(name)}
      norad={getDisplayValue(norad)}
    />
  );
};
